import Copy from "@assets/icons/copy.svg";
import { Button } from "@components/button";
import { BaseInput } from "@components/input";
import { FlexLoader } from "@components/loader";
import { Modal } from "@components/modal";
import { useBalanceDispatch } from "@features/balance";
import { copyToClipboard, withErrorHandling } from "@helpers/utilities";
import { useEffect, useState } from "react";
import styles from "./modal.module.scss";
import { Timer } from "@components/timer";

type Props = {
  isOpen: boolean;
  hide: () => void;
};

export const TopUpBalanceModal = ({ hide, isOpen }: Props) => {
  const [currentModal, setCurrentModal] = useState<"initial" | "topUp">(
    "initial"
  );

  const handleInitialModalClose = () => {
    setCurrentModal("topUp");
  };

  const handleTopUpModalClose = () => {
    hide();
    setCurrentModal("initial");
  };

  if (!isOpen) {
    return null;
  }

  return (
    <>
      {currentModal === "initial" && (
        <InitialModal hide={handleInitialModalClose} />
      )}

      {currentModal === "topUp" && <TopUpModal hide={handleTopUpModalClose} />}
    </>
  );
};

type InnerModalProps = Pick<Props, "hide">;

const InitialModal = ({ hide }: InnerModalProps) => {
  return (
    <Modal
      className={styles.initialModal}
      isOpen={true}
      onClose={hide}
      title="Предупреждение"
    >
      <p className={styles.description}>
        Все созданные кошельки для пополнения, временные - вы можете отправить
        средства в течении 15 минут.
      </p>
      <p className={styles.description}>
        Средства отправленные по истечении срока не подлежат зачислению на
        баланс.
      </p>
      <p className={styles.description}>
        Минимальная сумма пополнения 150 USDT
      </p>
      <Button className={styles.button} onClick={hide}>
        ОК
      </Button>
    </Modal>
  );
};

const TopUpModal = ({ hide }: InnerModalProps) => {
  const { getAssignWallet } = useBalanceDispatch();
  const [isLoadingAssignWallet, setIsLoadingAssignWallet] = useState(false);
  const [assignWallet, setAssignWallet] = useState<string>();
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [error, setError] = useState<string>();

  useEffect(() => {
    withErrorHandling(
      async () => {
        setIsLoadingAssignWallet(true);

        const response = await getAssignWallet();
        setError(undefined);
        setAssignWallet(response.address);
        setEndDate(new Date(response.created_at_unix * 1000 + 15 * 60 * 1000));
      },
      setError,
      () => setIsLoadingAssignWallet(false)
    );
  }, [getAssignWallet]);

  return (
    <Modal
      className={styles.modal}
      isOpen={true}
      onClose={hide}
      title="Пополнение баланса"
    >
      {isLoadingAssignWallet || endDate == null ? (
        <FlexLoader />
      ) : !assignWallet || error ? (
        <span>{error || "Произошла ошибка"}</span>
      ) : (
        <>
          <BaseInput
            className={styles.input}
            label="Адрес кошелька"
            value={assignWallet}
            icon={<Copy />}
            onClick={() => {
              copyToClipboard(assignWallet);
            }}
          />
          <p className={styles.addressTemporary}>
            Учитывайте, что кошелек временный
          </p>
          <BaseInput disabled label="Сеть" value="TRC 20" />
          <Timer
            endDate={endDate}
            withIcon={false}
            styles={{
              wrapper: {
                justifyContent: "center",
                marginTop: "20px",
              },
              label: {
                fontSize: "32px"
              }
            }}
          />
          <Button className={styles.button} onClick={hide}>
            Готово
          </Button>
        </>
      )}
    </Modal>
  );
};
